import React from 'react'
import {Carousel, Footer, QethjeLarje, TableComp} from "../../Components/index.js"

const Services = () => {
  return (
    <div>
      <Carousel/>
      <TableComp/>
      <Footer/>
    </div>
  )
}

export default Services